import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import { IPlInsightsState } from "./plInsights.types";
import { fetchPlInsightsAutomobileData, fetchPlInsightsHabitationalData } from "./plInsightsThunk";

export const plInsightsInitialState: IPlInsightsState = {
  automobileInsights: {
    loading: LoadState.NotLoaded,
    error: null,
    data: null,
  },
  habitationalInsights: {
    loading: LoadState.NotLoaded,
    error: null,
    data: null,
  },
};

const plInsightsSlice = createSlice({
  name: "plInsights",
  initialState: plInsightsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    // Automobile
    builder.addCase(fetchPlInsightsAutomobileData.pending, (state) => {
      state.automobileInsights.loading = LoadState.InProgress;
      state.automobileInsights.data = null;
      state.automobileInsights.error = null;
    });
    builder.addCase(fetchPlInsightsAutomobileData.fulfilled, (state, action) => {
      state.automobileInsights.loading = LoadState.Loaded;
      state.automobileInsights.data = action.payload;
    });
    builder.addCase(fetchPlInsightsAutomobileData.rejected, (state, action) => {
      state.automobileInsights.loading = LoadState.Failed;
      state.automobileInsights.error = action.payload as string;
    });
    // Habitational
    builder.addCase(fetchPlInsightsHabitationalData.pending, (state) => {
      state.habitationalInsights.loading = LoadState.InProgress;
      state.habitationalInsights.data = null;
      state.habitationalInsights.error = null;
    });
    builder.addCase(fetchPlInsightsHabitationalData.fulfilled, (state, action) => {
      state.habitationalInsights.loading = LoadState.Loaded;
      state.habitationalInsights.data = action.payload;
    });
    builder.addCase(fetchPlInsightsHabitationalData.rejected, (state, action) => {
      state.habitationalInsights.loading = LoadState.Failed;
      state.habitationalInsights.error = action.payload as string;
    });
  },
});

export default plInsightsSlice.reducer;
